import { Modal } from "react-bootstrap";
import "./CaptionPaymentModal.scss";

const CaptionPaymentModal = ({ show, plan, onHide }) => {
  if (!plan) {
    return null;
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="caption-payment-modal"
      aria-labelledby="caption-payment-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="caption-payment-title">
          Complete your {plan.name} plan
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="caption-payment-modal__summary">
          <div>
            <p className="caption-payment-modal__label">Selected plan</p>
            <p className="caption-payment-modal__plan">{plan.name}</p>
          </div>
          <div className="caption-payment-modal__amount">
            {plan.price}
            {plan.period}
          </div>
        </div>

        <p className="caption-payment-modal__note">
          Static checkout preview — payment processing will be connected in a later release.
        </p>

        <div className="caption-payment-modal__field">
          <label htmlFor="caption-payment-name">Full name</label>
          <input id="caption-payment-name" type="text" placeholder="Your name" />
        </div>

        <div className="caption-payment-modal__field">
          <label htmlFor="caption-payment-email">Email</label>
          <input id="caption-payment-email" type="email" placeholder="you@example.com" />
        </div>

        <div className="caption-payment-modal__field">
          <label htmlFor="caption-payment-card">Card number</label>
          <input id="caption-payment-card" type="text" placeholder="4242 4242 4242 4242" />
        </div>

        <div className="caption-payment-modal__row">
          <div className="caption-payment-modal__field">
            <label htmlFor="caption-payment-expiry">Expiry</label>
            <input id="caption-payment-expiry" type="text" placeholder="MM / YY" />
          </div>
          <div className="caption-payment-modal__field">
            <label htmlFor="caption-payment-cvc">CVC</label>
            <input id="caption-payment-cvc" type="text" placeholder="123" />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="caption-payment-modal__cancel" onClick={onHide}>
          Cancel
        </button>
        <button type="button" className="caption-payment-modal__pay" onClick={onHide}>
          Pay {plan.price}
          {plan.period}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CaptionPaymentModal;
